import { useQuery } from '@tanstack/react-query';
import { fetchLibxProduct } from './fetchLibxProduct';
import { LoanFormat } from '../../../../../models/LoanFormat';
import { globalErrorResponse } from '../../../../store/notifications/actions';
import { useDispatch } from 'react-redux';
import { browserClient } from '../../../../react-query';

export const LIBX_PRODUCT_KEY = 'libxProduct';
export const useLibxProduct = (id: string) => {
    const dispatch = useDispatch();

    const { data, ...rest } = useQuery([LIBX_PRODUCT_KEY, id], () => fetchLibxProduct(id), {
        enabled: !!id,
        onError: () => {
            dispatch(globalErrorResponse(`Failed to fetch product.`));
        }
    });

    return {
        data: {
            ...data!,
            // The loanFormat in the response is EBOOKS, but we need to use a lower case value for the frontend
            loanFormat: LoanFormat.eBooks,
            id
        },
        ...rest
    };
};

export const invalidateLibxProduct = (productId: string) => {
    return browserClient.invalidateQueries([LIBX_PRODUCT_KEY, productId]);
};
